"use client"

import React, { useEffect, useState } from "react"
import Header from "./components/Header.tsx"
import HeroSection from "./components/HeroSection.tsx"
import MultimodalSection from "./components/MultimodalSection.tsx"
import NodesShowcase from "./components/NodesShowcase.tsx"
import CaseStudies from "./components/CaseStudies.tsx"
import PricingSection from "./components/PricingSection.tsx"
import FAQSection from "./components/FAQSection.tsx"
import Footer from "@/components/Footer"

function ComingSoonModal({ visible, onClose }: { visible: boolean; onClose: () => void }) {
  useEffect(() => {
    if (!visible) return
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose()
    }
    document.addEventListener("keydown", handleKey)
    return () => document.removeEventListener("keydown", handleKey)
  }, [visible, onClose])

  if (!visible) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
        aria-hidden
      />

      <div className="relative z-10 mx-4 max-w-lg rounded-lg bg-white p-6 shadow-lg">
        <h2 className="mb-2 text-lg font-semibold">Coming soon</h2>
        <p className="mb-4 text-sm text-gray-700">This service is not yet available in your region at this time. Please check back later for more information.</p>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="rounded bg-purple-700 px-4 py-2 text-sm font-medium text-white hover:bg-purple-800"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  )
}

export default function Home() {
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    // Show the modal on first load. If you want to gate this behind a condition
    // (for example only for certain regions) you can replace this with logic.
    const t = setTimeout(() => setShowModal(true), 250)
    return () => clearTimeout(t)
  }, [])

  return (
    <div
      className="min-h-screen bg-gradient-to-b from-purple-950 via-purple-900 to-purple-800"
    >
      <Header />
      <main>
        <div className="pb-8" style={{ background: "url(https://images.pexels.com/photos/4175060/pexels-photo-4175060.jpeg)" }}>
          <HeroSection />
          <MultimodalSection />
        </div>
        {/* <NodesShowcase /> */}
        {/* <CaseStudies /> */}
        <PricingSection />
        <FAQSection />
      </main>
      <Footer />

      <ComingSoonModal visible={showModal} onClose={() => 1 || setShowModal(false)} />
    </div>
  )
}
